// src/pages/LandingPage.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import "./LandingPage.css";
import Hero from "../../components/Hero/Hero";
import FAQ from "../../components/FAQ/FAQ";
import Footer from "../../components/Footer/Footer";
import TestimonialsNew from "../../components/Testimonials/TestimonialNew";
import useAuthStore from "../../stores/authStore"; // ✅ your store

const LandingPage = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore(); // get current user from store

  useEffect(() => {
    document.title = "Home | Brandly";
    if (user?.id) {
      // user already logged in
      navigate("/dashboard", { replace: true });
    } else {
      // optionally, you can fetch /auth/me if you want to refresh store
      // but you can skip this to make it faster
    }
  }, [user, navigate]);

  // optionally show nothing while redirecting
  if (user?.id) return null;

  return (
    <div className="landing-wrapper">
      <Navbar />

      <main className="main-content">
        <Hero />
        <TestimonialsNew />
        <FAQ />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;
